export default "__VITE_ASSET__5kYNzFbD__"